export default {
  LANGUAGE_ENGLISH: 'en',
  LANGUAGE_SPANISH: 'es',
  LANGUAGE_PORTUGUESE: 'pt',
  LANGUAGE_GERMAN: 'de',
  LANGUAGE_ITALIAN: 'it',
  LANGUAGE_FRENCH: 'fr',

  codes() {
    return [
      this.LANGUAGE_ENGLISH,
      this.LANGUAGE_FRENCH,
      this.LANGUAGE_GERMAN,
      this.LANGUAGE_ITALIAN,
      this.LANGUAGE_PORTUGUESE,
      this.LANGUAGE_SPANISH,
    ];
  },
};
